import {Component, input} from '@angular/core';
import {Params, RouterLink} from '@angular/router';
import {MatTooltip} from '@angular/material/tooltip';

export type CheckStripTone = 'ok' | 'warn' | 'error' | 'alert' | 'none';

export interface CheckStripItem {
    tone: CheckStripTone;
    title?: string;
    /** Router link of the bar, e.g. the platform with only the checkpoints of that level. */
    link?: string | unknown[] | null;
    queryParams?: Params | null;
}

/**
 * Colored bars per check result. `sm`: 14×6 bars (one per checkpoint level in the platform list),
 * `lg`: full width strip of the last checks (checkpoint detail). Bars with a `link` are router links.
 */
@Component({
    selector: 'app-check-strip',
    imports: [MatTooltip, RouterLink],
    templateUrl: './check-strip.component.html',
    styleUrl: './check-strip.component.scss',
    host: {
        '[class]': 'size()'
    }
})
export class CheckStripComponent {
    readonly items = input<CheckStripItem[]>([]);
    readonly size = input<'sm' | 'lg'>('sm');
}
